import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import OrgUnitLogoImage from '../components/pages/org-unit/logo/content';

function OrganisationalUnitLogoImagePage(props) {
  const dispatch = useDispatch();

  const organisationalUnitLogoImageForm = useSelector(
    (state) => state.organisationsReducer.organisationalUnitLogoImageForm
  );
  const organisation = useSelector((state) => state.organisationsReducer.selectedOrgUnit);
  const showOrganisationalUnitLogoImageModal = useSelector(
    (state) => state.modalReducer.showOrganisationalUnitLogoImageModal
  );

  return (
    <div>
      <OrgUnitLogoImage
        dispatch={dispatch}
        showOrganisationalUnitLogoImageModal={showOrganisationalUnitLogoImageModal}
        organisation={organisation}
        organisationalUnitLogoImageForm={organisationalUnitLogoImageForm}
        readOnly={props.readOnly}
      />
    </div>
  );
}

export default OrganisationalUnitLogoImagePage;
